import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { TypedMemo } from '../../common/types';
import { SMLRouteNames } from '../../../routing/sml/SMLRoutes';
import { legacyStudioSearch } from './studioRoute';

interface PromoteLegacyRedirectProps {
  /** The old route: Reel Studio (`promoteReels`) or the Clip Studio (`promoteClips`). */
  from: 'reels' | 'clips';
}

/**
 * The old Reel Studio and Clip Studio routes. Both are gone (spec D24, D28), so a saved link opens
 * the Studio. A Reel Studio link opens the AI reel theme. A Clip Studio link opens the Short
 * format, where the user picks the theme. The query stays, so `?accountId=`,
 * `?catalogItemUuid=` and `?reel=` still reach the Studio.
 */
const PromoteLegacyRedirectComponent: React.FC<PromoteLegacyRedirectProps> = ({ from }) => {
  const { search } = useLocation();

  return (
    <Navigate
      to={`/${SMLRouteNames.promote}/${SMLRouteNames.promoteStudio}${legacyStudioSearch(search, from)}`}
      replace
    />
  );
};

export const PromoteLegacyRedirect = TypedMemo(PromoteLegacyRedirectComponent);
